/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { McgInformedService } from 'app/ext/mcg-informed/services/mcg-informed-service';
import { I18N } from 'aurelia-i18n';
import * as Mcg from 'app/ext/mcg-informed/interfaces';

@autoinject
export class QualityMeasures extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    @bindable
    public assessmentAttachmentId: string | null = null;

    protected qualityMeasure: Mcg.QualityMeasure | null = null;

    protected showCitationsI18n: string = this.i18n.tr('ui:actions.show', { count: 2, what: '$t(ui:labels.citation.$)' });
    protected hideCitationsI18n: string = this.i18n.tr('ui:actions.hide', { count: 2, what: '$t(ui:labels.citation.$)' });

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly mcgService: McgInformedService,
        private readonly i18n: I18N,
        ...rest: any[]
    ) {

        super(...rest);
        this.logger.source = this;
    }

    protected async bind(): Promise<void> {

    }

    protected async attached() {
        this.loadQualityMeasures();
    }

    protected async detached() {

    }

    ////****************** Functions ************************************************////

    protected getContentText(content: Mcg.QualityMeasureContent): string {
        let contentText: string = content.text;
        if(content.citationLinks == null) return contentText;

        content.citationLinks.forEach(link => {
            contentText = contentText.replace(link.citationLabelText, ` [${link.citationNumber}]`)
        });

        return contentText;
    }

    protected toggleCitations(citationsLink: HTMLAnchorElement): void {
        let citationDetails: HTMLElement = citationsLink;

        citationsLink.parentElement?.parentElement?.childNodes.forEach(n => {
            if(n.nodeName == 'DIV') {
                const e: HTMLElement = <HTMLElement>n;
                if(e.classList.contains('citation-details')) citationDetails = e;
            }
        });

        if(citationDetails == citationsLink) return;

        if(citationsLink.innerHTML === this.showCitationsI18n) citationsLink.innerHTML = this.hideCitationsI18n;
        else citationsLink.innerHTML = this.showCitationsI18n;
        citationDetails.classList.toggle('citation-details-hide');
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    private async loadQualityMeasures(): Promise<void> {
        if(this.assessmentAttachmentId == null) return;

        try {
            this.state.beginLoad();

            const response = await this.mcgService.loadQualityMeasures(this.assessmentAttachmentId);
            this.qualityMeasure = response.result;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}
